import React from "react"
import { Box, Text } from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import PublicTitleRow from "components/settings/PublicTitleRow"
import { DioboxEvent } from "sharedTypes"
import * as Yup from "yup"
import ConfigBlock from "../ConfigBlock"
import ModalContentWrapper from "./ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void>
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const EventTitleSchema = Yup.object().shape({
  portalShowEventTitle: Yup.boolean(),
})

const EventTitleModal = ({
  onHide,
  event: {
    publicEventTitle,
    portalShowEventTitle,
  },
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const values = {
    portalShowEventTitle,
  }

  const handleSubmit = async (data) => {
    await updateEvent({ portalShowEventTitle: data.portalShowEventTitle })
    onHide()
  }

  const handleCancel = () => {
    onHide()
    onResetEventWorkingCopy()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={values}
      title="Public Event Title"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
      showCloseWhenNotDirty
      validationSchema={EventTitleSchema}
    >
      {({ control, watch }) => {
        const enabled = watch("portalShowEventTitle")

        return (
          <ModalContentWrapper>
            <ConfigBlock title="Enabled" switchName="portalShowEventTitle" control={control}>
              <Box pt={4}>
                <Box mb={4}>
                  <Text>
                    Use a different title for public-facing areas of your event. The internal event
                    name used in Diobox will remain unchanged.
                  </Text>
                </Box>
                <PublicTitleRow
                  label=""
                  value={publicEventTitle ?? ""}
                  updateEvent={updateEvent}
                  onChangeEventWorkingCopy={onChangeEventWorkingCopy}
                  onResetEventWorkingCopy={onResetEventWorkingCopy}
                  isDisabled={!enabled}
                  inputMaxW="md"
                  variant="outline"
                />
                {!enabled && (
                  <Text fontSize="sm" color="gray.500" mt={2}>
                    Enable this setting to edit the public title.
                  </Text>
                )}
              </Box>
            </ConfigBlock>
          </ModalContentWrapper>
        )
      }}
    </ModalForm>
  )
}

export default EventTitleModal
